/** Angular and 3rd party dependencies */
import { Component, OnInit, Input, Output, EventEmitter, forwardRef, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, Validators, NG_VALIDATORS, NG_VALUE_ACCESSOR, FormGroup, FormControl, ControlValueAccessor } from '@angular/forms';
import { Router } from '@angular/router';

/** In app dependencies */
import { Tooltip } from 'src/app/model/tooltip';
import { RangeValidationConfig } from 'src/app/model/rangeValidation.model';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'app-day-month-year-dropdown',
    templateUrl: './day-month-year-dropdown.component.html',
    styleUrls: ['./day-month-year-dropdown.component.scss'],
    providers: [
        {
            provide: NG_VALIDATORS, useExisting: DayMonthYearDropdownComponent, multi: true
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DayMonthYearDropdownComponent),
            multi: true
        }
    ]
})
export class DayMonthYearDropdownComponent implements OnInit, Validators, ControlValueAccessor, OnChanges {
    years: number[] = [];
    months: string[] = [];
    days: number[] = [];
    temp: string[] = [];

    selectedYear: number = null;
    selectedMonth: number = null;
    selectedDay: number = null;

    isInvalidDate: boolean = false;
    isValidDateSelected: boolean = true;
    public isStartDateThreeMonthsError: boolean = false;
    public flagArray: Array<boolean> = [false, false];
    public textValue: string;
    selectForm: FormGroup;

    eventSubscription: Subscription;

    @Input() date: Observable<void>;
    @Input() controllerData;
    @Input() parent: UntypedFormGroup;
    @Input() tooltipData: Tooltip;
    @Input() pageName: string;
    @Input() minValue: string;
    @Input() allowFutureDate: boolean = false;
    @Input() commencementDateConfigObj: RangeValidationConfig;
    @Input() startDateAgeRangeConfigObj: RangeValidationConfig;
    @Input() maxValue: string;

    @Output() onBlurHandler: EventEmitter<any> = new EventEmitter<any>();

    defaultyear: string
    disabled: boolean;

    constructor(public router: Router,) {
        this.selectForm = new FormGroup({
            day: new FormControl('', Validators.required),
            month: new FormControl('', Validators.required),
            year: new FormControl('', Validators.required)
        });
    }

    ngOnInit(): void {
        this.populateYearDropdown();
        this.populateMonthDropdown();
        this.populateDateDropdown();

        if (this.date) {
            this.eventSubscription = this.date.subscribe(() => this.setToday());
        }

        if (this.parent.get(['dateOfBirth']).value != null && this.parent.get(['dateOfBirth']).value != "") {
            this.textValue = this.parent.get(['dateOfBirth']).value;
            this.selectedDay = parseInt(this.textValue.split(" / ")[0]);
            this.selectedMonth = parseInt(this.textValue.split(" / ")[1]);
            this.selectedYear = parseInt(this.textValue.split(" / ")[2]);
        } else {
            this.textValue = "";
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['date']) {
            if (changes['date'].currentValue == "true") {
                var today = new Date();
                this.textValue = today.getDate().toString().padStart(2, '0') + " / " + (today.getMonth() + 1).toString().padStart(2, '0') + " / " + today.getFullYear();
                this.selectedDay = today.getDate();
                this.selectedMonth = today.getMonth() + 1;
                this.selectedYear = today.getFullYear();
            }
        }
    }
    onTouched: () => void;

    onChange = (value: string) => { };

    setToday() {
        console.log("Button pressed")
        var today = new Date();
        this.textValue = today.getDate().toString().padStart(2, '0') + " / " + (today.getMonth() + 1).toString().padStart(2, '0') + " / " + today.getFullYear();
        this.selectedDay = today.getDate();
        this.selectedMonth = today.getMonth() + 1;
        this.selectedYear = today.getFullYear();
        this.onChangeOfDropdown(null);
    }

    writeValue(value: any): void {
        this.controllerData.value = value ? value : null;
    }

    registerOnChange(fn) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    validate() {
        if (this.isValidDateSelected) {
            return null;
        } else {
            return { error: true }
        }
    }

    onChangeOfDropdown(data?: any) {
        this.parent.get(this.controllerData.controlName).markAsTouched();

        const day = this.selectedDay;
        const month = this.selectedMonth - 1;
        const year = this.selectedYear;

        this.isInvalidDate = !this.isValidDate(year, month, day)
        console.log("isValidDate: " + !this.isInvalidDate);
        if (!this.isInvalidDate) {
            this.isValidDateSelected = this.validateSelectedDate(new Date(year, month, day))
        } else {
            this.isValidDateSelected = false;
        }

        if (this.isValidDateSelected) {
            this.textValue = day.toString().padStart(2, '0') + " / " + (month + 1).toString().padStart(2, '0') + " / " + year;
        } else {
            this.textValue = ""
        }
        console.log(this.isValidDateSelected, this.textValue);
    }

    isValidDate(year: number, month: number, day: number): boolean {
        if (year == null || month == null || day == null) {
            return false;
        }

        var d = new Date(year, month, day);
        if (d.getFullYear() == year && d.getMonth() == month && d.getDate() == day) {
            return true;
        }
        return false;
    }

    validateSelectedDate(selectedDate: Date): boolean {
        var today = new Date();

        if (this.allowFutureDate) {
            var temp = this.maxValue.split('.');
            var maxYear = parseInt(temp[0]);
            var maxMonth = parseInt(temp[1]);

            var minDateAllowed = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            var maxDateAllowed = new Date(today.getFullYear() + maxYear, today.getMonth() + maxMonth, today.getDate());
        } else {
            var temp = this.minValue.split('.');
            var minYear = parseInt(temp[0]);
            var minMonth = parseInt(temp[1]);

            temp = this.maxValue.split('.');
            var maxYear = parseInt(temp[0]);
            var maxMonth = parseInt(temp[1]);

            var minDateAllowed = new Date(today.getFullYear() - minYear, today.getMonth() - minMonth, today.getDate()); // new Date(today.getFullYear() - minYear, 0, 1) if no check required for min year
            var maxDateAllowed = new Date(today.getFullYear() - maxYear, today.getMonth() - maxMonth, today.getDate());
        }

        console.log("selectedDate: " + selectedDate + " minDate: " + minDateAllowed + " maxDate: " + maxDateAllowed);
        console.log("(this.getDateDifference(minDateAllowed, selectedDate) " + this.getDateDifference(minDateAllowed, selectedDate));
        console.log("this.getDateDifference(selectedDate, maxDateAllowed) " + this.getDateDifference(selectedDate, maxDateAllowed));

        if ((selectedDate >= minDateAllowed) && (selectedDate <= maxDateAllowed)) {
            this.flagArray = [false, false];
        } else {
            this.flagArray = [true, true];
            if (this.allowFutureDate) {
                this.isStartDateThreeMonthsError = true;
            } else {
                this.isStartDateThreeMonthsError = false;
            }
        }
        this.onBlurHandler.emit(this.flagArray);

        return (selectedDate >= minDateAllowed) && (selectedDate <= maxDateAllowed);
    }

    populateDateDropdown(): void {
        this.days = [];
        const daysInMonth = new Date(this.selectedYear, this.selectedMonth + 1, 0).getDate();
        for (let i = 1; i <= daysInMonth; i++) {
            this.days.push(i);
        }
    }

    populateMonthDropdown(): void {
        const monthNames = [
            "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
        ];
        this.months = monthNames;
    }

    populateYearDropdown(): void {
        const today = new Date();

        var targetDate, startDate, startYear, targetYear;

        var temp = this.maxValue.split(".");
        var maxYear = parseInt(temp[0]);
        var maxMonth = parseInt(temp[1]);

        if (this.allowFutureDate) {
            startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            targetDate = new Date(today.getFullYear() + maxYear, today.getMonth() + maxMonth, today.getDate());
        } else {
            temp = this.minValue.split(".");
            var minYear = parseInt(temp[0]);
            var minMonth = parseInt(temp[1]);

            targetDate = new Date(today.getFullYear() - maxYear, today.getMonth() - maxMonth, today.getDate());
            startDate = new Date(today.getFullYear() - minYear, today.getMonth() - minMonth, today.getDate());
        }

        startYear = startDate.getFullYear();
        targetYear = targetDate.getFullYear();

        this.years = this.getYearsBetweenRange(startYear, targetYear);
    }

    getYearsBetweenRange(startYear: any, targetYear: any): number[] {
        const years: number[] = [];
        for (let year = targetYear; year >= startYear; year--) {
            years.push(year);
        }
        return years;
    }

    getDateDifference(startDate: Date, endDate: Date): { years: number; months: number; days: number } {
        let years = endDate.getFullYear() - startDate.getFullYear();
        let months = endDate.getMonth() - startDate.getMonth();
        let days = endDate.getDate() - startDate.getDate();

        if (days < 0) {
            months--;
            const previousMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0); // Last day of previous month
            days += previousMonth.getDate();
        }

        if (months < 0) {
            years--;
            months += 12;
        }

        return { years, months, days };
    }
}
